// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081/api/v1';

// App Info
export const APP_NAME = 'TIGOON Connect';
export const APP_TAGLINE = 'La meilleure application pour les chauffeurs VTC';
export const COPYRIGHT_YEAR = new Date().getFullYear();

// App Store Links (to be updated with real links)
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.tigoon.connect';
export const APP_STORE_URL = 'https://apps.apple.com/app/tigoon-connect/id123456789';

// App Store Availability - Set to true when iOS app is published
export const APP_STORE_AVAILABLE = false;

// Colors - Based on TIGOON Logo (Gold & Dark)
export const COLORS = {
    primary: '#D4A853',        // Gold/Doré
    primaryLight: '#F5E6C8',   // Light gold
    primaryDark: '#B8912F',    // Dark gold
    secondary: '#2D3436',      // Dark charcoal (logo background)
    text: '#2D3436',
    textLight: '#595959',
    textMuted: '#8c8c8c',
    background: '#ffffff',
    backgroundAlt: '#f8f9fa',
};

// Features list with detailed content
export const FEATURES = [
    {
        key: 'sos-credit',
        title: 'SOS Crédit',
        description: 'Besoin de crédit en urgence ? Obtenez un prêt instantané directement depuis l\'application.',
        icon: 'thunderbolt',
        color: '#fa8c16',
        fullDescription: 'Le service SOS Crédit de TIGOON Connect vous permet d\'obtenir un crédit instantané directement depuis votre application mobile. Conçu spécialement pour les chauffeurs VTC, ce service vous offre une solution rapide et fiable lorsque vous avez besoin de liquidités pour continuer à travailler.',
        benefits: [
            'Crédit instantané disponible 24h/24',
            'Processus de demande simplifié en quelques clics',
            'Taux d\'intérêt compétitifs et transparents',
            'Remboursement flexible adapté à vos revenus',
            'Aucune paperasse ni déplacement nécessaire',
            'Approbation automatique basée sur votre historique'
        ],
        howItWorks: [
            { step: 1, title: 'Faites votre demande', description: 'Accédez à la section SOS Crédit et indiquez le montant souhaité.' },
            { step: 2, title: 'Validation instantanée', description: 'Notre système analyse votre profil et valide votre demande en quelques secondes.' },
            { step: 3, title: 'Réception des fonds', description: 'Le crédit est directement crédité sur votre compte TIGOON.' },
            { step: 4, title: 'Remboursement automatique', description: 'Le remboursement est prélevé automatiquement sur vos prochains gains.' }
        ]
    },
    {
        key: 'transfers',
        title: 'Transferts UV',
        description: 'Transférez des unités de valeur facilement vers d\'autres chauffeurs partenaires.',
        icon: 'swap',
        color: '#52c41a',
        fullDescription: 'La fonctionnalité Transferts UV vous permet de transférer des unités de valeur (UV) vers d\'autres chauffeurs partenaires TIGOON Connect. Une solution pratique pour partager des ressources entre collègues ou régler des transactions entre chauffeurs.',
        benefits: [
            'Transferts instantanés entre chauffeurs',
            'Aucun frais de transfert entre partenaires',
            'Historique complet de toutes vos transactions',
            'Notifications en temps réel pour l\'expéditeur et le destinataire',
            'Limite de transfert quotidienne sécurisée',
            'QR Code pour des transferts encore plus rapides'
        ],
        howItWorks: [
            { step: 1, title: 'Sélectionnez le destinataire', description: 'Recherchez le chauffeur par son nom ou scannez son QR Code.' },
            { step: 2, title: 'Entrez le montant', description: 'Indiquez le nombre d\'UV que vous souhaitez transférer.' },
            { step: 3, title: 'Confirmez le transfert', description: 'Vérifiez les détails et validez avec votre code PIN.' },
            { step: 4, title: 'Transfert effectué', description: 'Les UV sont instantanément crédités sur le compte du destinataire.' }
        ]
    },
    {
        key: 'classe-service',
        title: 'Classe de Service',
        description: 'Changez la classe de service de votre véhicule selon vos besoins.',
        icon: 'setting',
        color: '#1890ff',
        fullDescription: 'Adaptez votre offre de service en fonction de la demande et de vos préférences. La fonctionnalité Classe de Service vous permet de basculer facilement entre différentes catégories de service (Économique, Confort, Premium) pour maximiser vos opportunités de courses.',
        benefits: [
            'Flexibilité totale pour changer de classe à tout moment',
            'Accès à différents types de clientèle',
            'Optimisation de vos revenus selon la demande',
            'Tarification automatique adaptée à chaque classe',
            'Visibilité accrue auprès des clients premium',
            'Statistiques de performance par classe de service'
        ],
        howItWorks: [
            { step: 1, title: 'Accédez aux paramètres', description: 'Ouvrez la section "Mon véhicule" dans l\'application.' },
            { step: 2, title: 'Choisissez votre classe', description: 'Sélectionnez la classe de service souhaitée parmi celles disponibles.' },
            { step: 3, title: 'Vérification automatique', description: 'Le système vérifie que votre véhicule correspond aux critères.' },
            { step: 4, title: 'Activation immédiate', description: 'Votre nouvelle classe est active et vous recevez les courses correspondantes.' }
        ]
    },
    {
        key: 'ajout-vehicule',
        title: 'Ajout de Véhicule',
        description: 'Ajoutez facilement un nouveau véhicule à votre compte chauffeur.',
        icon: 'car',
        color: '#13c2c2',
        fullDescription: 'Vous possédez plusieurs véhicules ou venez d\'en acquérir un nouveau ? La fonctionnalité Ajout de Véhicule vous permet d\'enregistrer facilement un nouveau véhicule sur votre compte TIGOON Connect et de commencer à l\'utiliser pour vos courses.',
        benefits: [
            'Enregistrement rapide en quelques minutes',
            'Gestion de plusieurs véhicules sur un seul compte',
            'Vérification automatique des documents',
            'Basculement facile entre vos véhicules',
            'Suivi des performances par véhicule',
            'Alertes de maintenance et d\'assurance'
        ],
        howItWorks: [
            { step: 1, title: 'Initiez l\'ajout', description: 'Accédez à "Mes véhicules" et cliquez sur "Ajouter un véhicule".' },
            { step: 2, title: 'Renseignez les informations', description: 'Entrez les détails du véhicule (marque, modèle, immatriculation).' },
            { step: 3, title: 'Téléchargez les documents', description: 'Ajoutez la carte grise, l\'assurance et les photos du véhicule.' },
            { step: 4, title: 'Validation', description: 'Notre équipe vérifie et valide votre véhicule sous 24-48h.' }
        ]
    },
    {
        key: 'lier-vehicule',
        title: 'Se Lier à un Véhicule',
        description: 'Associez-vous à un véhicule existant pour commencer à travailler.',
        icon: 'link',
        color: '#52c41a',
        fullDescription: 'Vous êtes chauffeur et souhaitez utiliser le véhicule d\'un partenaire ? La fonctionnalité "Se Lier à un Véhicule" vous permet de vous associer temporairement ou définitivement à un véhicule déjà enregistré sur TIGOON Connect.',
        benefits: [
            'Démarrage rapide sans posséder de véhicule',
            'Flexibilité de travailler avec différents propriétaires',
            'Traçabilité complète des courses effectuées',
            'Répartition automatique des gains si configuré',
            'Historique des liaisons conservé',
            'Notifications au propriétaire du véhicule'
        ],
        howItWorks: [
            { step: 1, title: 'Demandez la liaison', description: 'Scannez le QR Code du véhicule ou entrez son identifiant.' },
            { step: 2, title: 'Attente d\'approbation', description: 'Le propriétaire reçoit une notification pour approuver la liaison.' },
            { step: 3, title: 'Liaison active', description: 'Une fois approuvé, vous pouvez utiliser ce véhicule pour vos courses.' },
            { step: 4, title: 'Suivi partagé', description: 'Les statistiques sont partagées entre vous et le propriétaire.' }
        ]
    },
    {
        key: 'detacher-vehicule',
        title: 'Se Détacher',
        description: 'Détachez-vous d\'un véhicule en toute simplicité quand vous le souhaitez.',
        icon: 'disconnect',
        color: '#eb2f96',
        fullDescription: 'Vous souhaitez mettre fin à votre association avec un véhicule ? La fonctionnalité "Se Détacher" vous permet de vous dissocier d\'un véhicule en quelques clics, que ce soit pour changer de partenaire ou pour toute autre raison.',
        benefits: [
            'Processus de détachement simple et rapide',
            'Aucune pénalité ni frais cachés',
            'Conservation de votre historique et statistiques',
            'Notification automatique au propriétaire',
            'Possibilité de se rattacher ultérieurement',
            'Rapport final de la période de liaison'
        ],
        howItWorks: [
            { step: 1, title: 'Accédez à votre liaison', description: 'Ouvrez la section "Mon véhicule actuel" dans l\'application.' },
            { step: 2, title: 'Demandez le détachement', description: 'Cliquez sur "Se détacher" et confirmez votre choix.' },
            { step: 3, title: 'Période de préavis', description: 'Un délai de grâce permet de finaliser les courses en cours.' },
            { step: 4, title: 'Détachement effectif', description: 'Vous êtes libre de vous lier à un autre véhicule.' }
        ]
    },
    {
        key: 'phone-change',
        title: 'Changement de Numéro',
        description: 'Changez votre numéro de téléphone sans perdre vos données.',
        icon: 'phone',
        color: '#722ed1',
        fullDescription: 'Vous avez changé de numéro de téléphone ? Pas de panique ! La fonctionnalité Changement de Numéro vous permet de mettre à jour votre numéro tout en conservant l\'intégralité de vos données, historique et paramètres.',
        benefits: [
            'Conservation de toutes vos données et historique',
            'Processus sécurisé avec double vérification',
            'Mise à jour instantanée sur tous les services',
            'Aucune interruption de service',
            'Notifications envoyées à vos contacts',
            'Ancien numéro désactivé automatiquement'
        ],
        howItWorks: [
            { step: 1, title: 'Initiez le changement', description: 'Accédez à "Mon profil" puis "Modifier mon numéro".' },
            { step: 2, title: 'Vérifiez l\'ancien numéro', description: 'Confirmez votre identité avec un code envoyé sur l\'ancien numéro.' },
            { step: 3, title: 'Entrez le nouveau numéro', description: 'Saisissez votre nouveau numéro de téléphone.' },
            { step: 4, title: 'Validation finale', description: 'Confirmez avec le code reçu sur le nouveau numéro.' }
        ]
    },
    {
        key: 'assistance',
        title: 'Assistance 24/7',
        description: 'Notre équipe est disponible à tout moment pour vous aider.',
        icon: 'customer-service',
        color: '#faad14',
        fullDescription: 'TIGOON Connect met à votre disposition une équipe d\'assistance disponible 24 heures sur 24, 7 jours sur 7. Que ce soit pour une question technique, un problème urgent ou simplement pour obtenir des conseils, nous sommes là pour vous.',
        benefits: [
            'Support disponible 24h/24 et 7j/7',
            'Assistance multicanal (chat, appel, email)',
            'Temps de réponse rapide garanti',
            'Équipe formée aux spécificités VTC',
            'Suivi personnalisé de chaque demande',
            'FAQ et tutoriels vidéo accessibles'
        ],
        howItWorks: [
            { step: 1, title: 'Contactez-nous', description: 'Utilisez le chat intégré, appelez ou envoyez un email.' },
            { step: 2, title: 'Décrivez votre problème', description: 'Expliquez votre situation à notre équipe.' },
            { step: 3, title: 'Solution personnalisée', description: 'Un conseiller analyse et propose une solution adaptée.' },
            { step: 4, title: 'Résolution et suivi', description: 'Votre problème est résolu et un suivi est assuré si nécessaire.' }
        ]
    }
];
